/** Client helpers for mortgage statement matching (mirrors server heuristics). */

export function looksLikeMortgageDescription(desc) {
  if (!desc) return false;
  const d = String(desc).toLowerCase();
  return /mortgage|mtg\b|freedom\s*mtg|loan\s*servic|pennymac|mr\s*cooper|nationstar|shellpoint|loan\s*care|wells\s*fargo.*loan|chase.*mtg|jpmorgan.*mtg|newrez|loandepot|rocket\s*mortgage|quicken\s*loans/i.test(d);
}
